<template>
  <div class="tm-form-item" :class="errorItem ? 'tm-form-item-error' : ''">
    <label
      v-if="attributes.label"
      class="tm-label"
      :class="isRequired ? 'is-required' : ''"
      :style="{ width: labelWidth }"
    >
      <div class="tm-label-title">
        <span class="tm-label-title-order">{{ attributes.orderNum }}</span>
        <div
          class="tm-label-title-label"
          v-html="formItem.component != 'tm-button' ? attributes.label : ''"
        ></div>
      </div>
    </label>
    <div
      class="tm-form-item-extra"
      v-if="labelPosition == 'top' && attributes.extraText"
      v-html="formItem.component != 'tm-button' ? attributes.extraText : ''"
    ></div>
    <div class="tm-form-item-content">
      <component
        class="tm-form-item-content-component"
        :is="formItem.component"
        v-bind="componentProps"
        @input="handleInput"
        @change="handleChange"
        @blur="handleBlur"
        @focus="handleFocus"
        @trigger="handleTrigger"
        @submit="handleSubmit"
        @click="handleClick"
      />
      <div
        class="tm-form-item-extra"
        v-if="labelPosition == 'left' && attributes.extraText"
      >
        {{ attributes.extraText }}
      </div>
      <div v-if="errorItem" class="error-message">
        <i class="dct-fonts-close"></i>
        <span>{{ errorItem }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { formTypes } from "./form";
import Schema from "async-validator";

export default {
  name: "tm-form-item",
  components: {
    ...formTypes,
  },
  props: {
    formItem: {
      type: Object,
      default: () => ({}),
    },
    labelPosition: {
      type: String,
      default: "left",
    },
    labelWidth: {
      type: String,
      default: "120px",
    },
    error: {
      type: String,
      default: "",
    },
  },
  computed: {
    attributes() {
      return this.formItem.attributes || {};
    },
    isRequired() {
      if (this.attributes.rules && Array.isArray(this.attributes.rules)) {
        return this.attributes.rules.some((rule) => rule.required);
      }
      return false;
    },
    componentProps() {
      return {
        name: this.attributes.prop,
        label: this.attributes.label,
        value: this.attributes.data || "",
        required: this.isRequired,
        disabled: this.attributes.disabled || false,
        placeholder: this.attributes.placeholder || "",
        type: this.attributes.type || "text",
        validation: this.attributes.rules,
        pattern: this.attributes.pattern,
        patternMessage: this.attributes.patternMessage,
        options: this.attributes.options,
        r: this.attributes.requestId || "",
        col: this.attributes.col,
      };
    },
  },
  watch: {
    error(newVal) {
      this.errorItem = newVal;
    },
  },
  data() {
    return {
      errorItem: "",
    };
  },
  methods: {
    handleInput(name, value) {
      this.$emit("input", name, value);
    },

    handleChange(name, value) {
      this.$emit("change", name, value);
    },

    handleBlur(name, value) {
      this.$emit("blur");
    },

    handleTrigger(name, value) {
      this.validate(name, value);
    },

    handleSubmit(r) {
      this.$emit("submit", r);
    },

    handleClick(r) {
      this.$emit("click", r);
    },

    handleFocus() {
      this.$emit("focus");
    },

    // 新增：校验规则标准化，确保min/max为数字
    normalizeRules(rules) {
      if (!Array.isArray(rules)) return [];
      return rules.map((rule) => {
        const normalizedRule = { ...rule };
        if (
          normalizedRule.min !== undefined &&
          typeof normalizedRule.min === "string"
        ) {
          normalizedRule.min = parseInt(normalizedRule.min);
        }
        if (
          normalizedRule.max !== undefined &&
          typeof normalizedRule.max === "string"
        ) {
          normalizedRule.max = parseInt(normalizedRule.max);
        }
        if (
          normalizedRule.required === "true" ||
          normalizedRule.required === true
        ) {
          normalizedRule.required = true;
        } else if (
          normalizedRule.required === "false" ||
          normalizedRule.required === false
        ) {
          normalizedRule.required = false;
        }
        return normalizedRule;
      });
    },

    validateField(name) {
      // 标准化规则
      const normalizedRules = this.normalizeRules(this.attributes.rules);
      let descriptor = {};
      descriptor[name] = normalizedRules;
      const validator = new Schema(descriptor);
      return validator;
    },

    async validate(name, value) {
      let isValid = true;
      let error = "";
      const validator = this.validateField(name);
      validator.validate({ [name]: value }, (errors) => {
        if (errors) {
          error = errors[0].message;
          isValid = false;
        }
      });
      this.errorItem = error;
      // 修复：发送错误消息而不是布尔值
      this.$emit("validate", name, error);
    },
  },
};
</script>
<style>
p {
  margin: 0;
}
</style>
<style scoped>
.tm-form-item {
  display: flex;
  margin-bottom: 20px;
  font-size: 14px;
}

.tm-form-container-top .tm-form-item .tm-label {
  text-align: left;
  margin-bottom: 10px;
  line-height: 1;
  padding-right: 0;
}

.tm-form-item-extra {
  color: #999;
  margin-bottom: 10px;
  text-align: left;
}

.tm-label-title {
  display: flex;
}

.tm-label-title-order {
  margin-right: 10px;
}

.tm-label {
  min-width: 120px;
  line-height: 40px;
  text-align: right;
  padding-right: 10px;
  box-sizing: border-box;
}

.is-required {
  position: relative;
  &::before {
    content: "*";
    position: absolute;
    left: -12px;
    top: 0;
    color: #e74c3c;
  }
}
.tm-form-item-content {
  position: relative;
  width: 100%;
}

.tm-form-item-content .tm-form-item-extra {
  line-height: 1;
  padding-left: 0;
  margin-top: 10px;
}

.tm-form-item-content-component {
  line-height: 40px;
}

.error-message {
  position: absolute;
  top: 100%;
  left: 0;
  color: #e74c3c;
  margin-top: 4px;
}

.error-message span,
.dct-fonts-close {
  vertical-align: middle;
}

.error-message span {
  margin-left: 4px;
}
</style>
